export const resource = (path: string) => {
    return `https://localhost:8989/kredittbank-kredittkort-betjening-web/rest/resource/v3${path}`;
};

export const v4Resource = (path: string) => {
    return `https://localhost:8989/kredittbank-kredittkort-betjening-web/rest/resource/v4${path}`;
};
